import {faBan, faCheck, faCircle, faCircleNotch} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import {Form, Table} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import APIErrorHelper from "../../../../../../helpers/APIErrorHelper";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import Switch from "react-switch";
import PluginHelper from "../../../../../../helpers/PluginHelper";

class ImportIsolationHardwareDialog extends React.Component {
  constructor(props) {
    super(props);
    this.exampleFile = `identifier;product;type;serialNumber;osVersion\ndrive_001;Fast Drive;1;123456;OS_1111-01-01`;
    this.importPatterns = {
      identifier: ["identifier"],
      product: ["product"],
      type: ["type"],
      serialNumber: ["serialNumber"],
      osVersion: ["osVersion"]
    }

    this.types = [
      "USB 2.0",
      "USB 3.0"
    ];

    this.state = {
      isLoading: false,
      importSuccessful: false,
      importIsolationHardware: [],
      hasErrors: false,
      updateOnSerial: false,
      dialogApiError: ""
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleUpload = this.handleUpload.bind(this);

    this.resolveStatus = this.resolveStatus.bind(this);
    this.validateImportData = this.validateImportData.bind(this);
    this.detectDataFormat = this.detectDataFormat.bind(this);
    this.delimiter = this.delimiter.bind(this);
  }

  handleHide() {
    this.setState({
      importIsolationHardware: [],
      dialogApiError: "",
      importSuccessful: false,
      isLoading: false,
      hasErrors: false,
      updateOnSerial: false
    });
    this.props.onHide();
  }

  async handleSubmit() {
    const {importedHardware, hasErrors} = await this.props
        .onSubmit(this.state.importIsolationHardware, this.state.updateOnSerial);
    this.setState({
      hasErrors,
      importSuccessful: hasErrors,
      isLoading: false,
      updateOnSerial: false,
      importIsolationHardware: hasErrors ? importedHardware : []
    });
  }

  async handleUpload(event) {
    this.setState({ isLoading: true });
    let isolationHardware = [];
    try {
      const text = await PluginHelper.readFileAsUTF8Text(event.target.files[0]);
      isolationHardware = await this.detectDataFormat(text);
      isolationHardware = isolationHardware.map(i => ({...i, errorCode: -1}))
      this.setState({
        isLoading: false,
        importIsolationHardware: isolationHardware,
        importSuccessful: true,
        dialogApiError: ""
      });
    } catch (err) {
      const error = APIErrorHelper.getError(
          { status: 412 },
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: `${this.props.t("Hardware.Tabs.IsolationHardware.Modal.Import.ImportError")} (${err.message})`
          },
          null
      );
      this.setState({
        isLoading: false,
        dialogApiError: error,
        importSuccessful: false
      });
    }
  }

  async validateImportData(importedData){
    const validatedData = [];
    for (const entry of importedData) {
      if (typeof entry["identifier"] === "undefined"
          || typeof entry["product"] === "undefined"
          || typeof entry["type"] === "undefined"
          || typeof entry["serialNumber"] === "undefined"
          || typeof entry["osVersion"] === "undefined"
          || !ValidationHelper.isString(entry["identifier"])
          || !ValidationHelper.isString(entry["product"])
          || !(Number.isFinite(parseInt(entry["type"])) && parseInt(entry["type"]) >= 0 && parseInt(entry["type"]) <= 1)
          || !ValidationHelper.isString(entry["serialNumber"])
          || !ValidationHelper.isTestedOS(entry["osVersion"])) {
        throw new Error("Invalid csv document given: Invalid format");
      }
      entry["type"] = parseInt(entry["type"]);
      validatedData.push(entry);
    }
    return validatedData;
  }

  delimiter(csvText) {
    try {
      const t = csvText.split("\n")[0];
      let delArray = [',', ';', '|', '    '];
      let comma, semicolon, pipe, tab;

      delArray.forEach((e, i) => {
        if (i === 0) {
          comma = t.split(e).length;
        } else if (i === 1) {
          semicolon = t.split(e).length;
        } else if (i === 2) {
          pipe = t.split(e).length;
        } else if (i === 3) {
          tab = t.split(e).length;
        }
      });
      let tmpArray1 = [comma, semicolon, pipe, tab]
      let tmpArray = [comma, semicolon, pipe, tab];
      let maxLen = tmpArray.sort((a, b) => b - a)[0];
      let delimiter_i = 0;
      tmpArray1.forEach((e, i) => {
        if (maxLen === e) {
          delimiter_i = i;
        }
      });
      if (delimiter_i === 0) {
        return ',';
      } else if (delimiter_i === 1) {
        return ';';
      } else if (delimiter_i === 2) {
        return '|';
      } else if (delimiter_i === 3) {
        return '    ';
      }
    }catch(err){
      console.error(err);
    }
    return ",";
  }

  async detectDataFormat(rawCSVData){
    const separator = this.delimiter(rawCSVData);
    let csvLinesOut = [];
    try {
      const csvLines = [];
      const lines = rawCSVData
          .replaceAll('"', '')
          .split("\n");
      const headers = lines[0]
          .replace(/ /, "")
          .trim()
          .split(separator)
          .map(i => i.trim());

      const nameMap = new Map();
      for (const field in this.importPatterns){
        headers.forEach(h => {
          if (this.importPatterns[field].indexOf(h) > -1 && !nameMap.has(h)){
            nameMap.set(h, field);
          }
        });
      }
      if (Object.keys(this.importPatterns).length !== nameMap.size){
        throw new Error("Invalid csv document given. Too many columns.");
      }
      lines.shift();
      lines.forEach(line => {
        const values = line.trim().split(separator).map(i => i.trim());
        if (values[0].length > 0
            && values[1].length > 0
            && values[2].length > 0
            && values[3].length > 0
            && values[4].length > 0){
          const entry = {};
          headers.forEach((h, idx) => {
            const processKey = nameMap.get(h);
            entry[processKey] = values[idx]
          });
          csvLines.push(entry);
        }
      });
      csvLinesOut = await this.validateImportData(csvLines);
    } catch (err) {
      throw new Error(err.message);
    }
    return csvLinesOut;
  }


  resolveStatus(t, errorCode){
    switch (errorCode) {
      case -1:
        return <FontAwesomeIcon icon={faCircle} className="color-black" />
      case 0:
        return <FontAwesomeIcon icon={faCheck} className="color-green" />
      case 412:
        return (<b><FontAwesomeIcon icon={faBan} className="color-red" /> {
          t("Hardware.Tabs.IsolationHardware.Modal.Import.APIError.PreconditionFailed")}</b>);
      case 409:
        return (<b><FontAwesomeIcon icon={faBan} className="color-red" /> {
          t("Hardware.Tabs.IsolationHardware.Modal.Import.APIError.CreateConflict")}</b>);
      default:
        return (<b><FontAwesomeIcon icon={faBan} className="color-red" /> {
          t("Hardware.Tabs.IsolationHardware.Modal.Import.APIError.ServerError")}</b>
      )
    }
  }

  render() {
    const { t } = this.props;
    const upload =
      !this.state.importSuccessful && !this.state.isLoading ? (
        <Form>
          <p>
            <b>{t("Hardware.Tabs.IsolationHardware.Modal.Import.Form.Description")}</b> <br />
            <b>{t("Hardware.Tabs.IsolationHardware.Modal.Import.Form.ExampleFileDescription")} <a
                href={`data:text/csv;charset=utf-8,${encodeURIComponent(this.exampleFile)}`}
                download={t("Hardware.Tabs.IsolationHardware.Modal.Import.Form.ExampleFileName")}>
              {t("Hardware.Tabs.IsolationHardware.Modal.Import.Form.ExampleFileName")}
            </a></b>
          </p>

          <Form.Group controlId="formUpdateOnSerial">
            <Form.Label>
              {t(
                  "Hardware.Tabs.IsolationHardware.Modal.Import.Form.UpdateOnMatchingSerial"
              )}{" "}
            </Form.Label>
            <Switch
                className="float-right"
                onColor="#54BF8D"
                checked={this.state.updateOnSerial}
                onChange={(state) => {
                  this.setState({updateOnSerial: state})
                }}
                height={18}
                width={40}
            />
          </Form.Group>
          <Form.File id="custom-file" label="Custom file input" custom>
            <Form.File.Input
              onChange={this.handleUpload}
              accept="text/csv"
            />
            <Form.File.Label
              data-browse={t("Hardware.Tabs.IsolationHardware.Modal.Import.Form.UploadButton")}
            />
          </Form.File>
        </Form>
      ) : (
        ""
      );
    const loading = this.state.isLoading ? (
      <div>
        <FontAwesomeIcon icon={faCircleNotch} spin />{" "}
        {t("Hardware.Tabs.IsolationHardware.Modal.Import.Loading")}
      </div>
    ) : (
      ""
    );
    const results = this.state.importSuccessful ? (
      <Table>
        <thead>
        <tr>
          <th>
            {t("Hardware.Tabs.IsolationHardware.ColumnIdentifier")}
          </th>
          <th>
            {t("Hardware.Tabs.IsolationHardware.ColumnProduct")}
          </th>
          <th>
            {t("Hardware.Tabs.IsolationHardware.ColumnType")}
          </th>
          <th>
            {t("Hardware.Tabs.IsolationHardware.ColumnSerialNumber")}
          </th>
          <th>
            {t("Hardware.Tabs.IsolationHardware.ColumnOsVersion")}
          </th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        {this.state.importIsolationHardware.length > 0 ? (this.state.importIsolationHardware.map((i, idx) => (
            <tr key={idx}>
              <td>{i.identifier}</td>
              <td>{i.product}</td>
              <td>{this.types[i.type]}</td>
              <td>{i.serialNumber}</td>
              <td>{i.osVersion}</td>
              <td>{this.resolveStatus(t, i.errorCode)}</td>
            </tr>
        ))) : (
            <tr>
              <td rowSpan="6">
                {t("Hardware.Tabs.IsolationHardware.Modal.Import.NoData")}
              </td>
            </tr>
        )}
        </tbody>
      </Table>
    ) : (
      ""
    );
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.handleHide}
        title={t("Hardware.Tabs.IsolationHardware.Modal.Import.Title")}
        dialogApiError={this.state.dialogApiError}
        leftButtonCallback={this.handleHide}
        leftButtonText={t("DialogCancel")}
        leftButtonVariant="black"
        rightButtonCallback={this.handleSubmit}
        rightButtonText={t("Hardware.Tabs.IsolationHardware.Modal.Import.Form.Submit")}
        rightButtonVariant="green"
        rightButtonDisabled={!(this.state.importIsolationHardware.length > 0) || this.state.hasErrors}
        body={(<>
          {upload}
          {loading}
          {results}
        </>)}
      />
    );
  }
}

export default withTranslation()(ImportIsolationHardwareDialog);
